import React from "react";
import Button from "../Buttons";
import { BuyCart } from "../../assets/images";
import styled from "styled-components";
import { checkIfGivenDateNotRestricted } from "../../helper";
import dayjs from "dayjs";

const StickyCart = ({
  onAddToCart,
  amount,
  offerProducts,
  newProductQty,
  cartProductQty,
  isEnabled,
  restrictedDate,
  date,
}) => {
  const hasNoRestriction = checkIfGivenDateNotRestricted(
    restrictedDate,
    dayjs(date).format("YYYY-MM-DD")
  );
  const getSum = (array, key) => {
    let sum = 0;
    array.forEach((item) => {
      if (item[key] !== undefined) {
        sum += item[key];
      }
    });
    return sum;
  };

  const totalSum =
    offerProducts?.length > 0
      ? offerProducts?.reduce((acc, key) => {
          return acc + getSum(cartProductQty, key) + getSum(newProductQty, key);
        }, 0)
      : 0;
  return (
    <StyledStickyCart>
      <StyledStickyCartInner>
        {isEnabled && hasNoRestriction && (
          <>
            {totalSum > 0 ? (
              <div>
                <ItemAddedText>{totalSum} item added</ItemAddedText>
                {totalSum >= 4 ? (
                  <WhiteText>Buy 6 (Pay for 4 – 2 tickets free!)</WhiteText>
                ) : (
                  <WhiteText>Buy 4 (Pay for 3 – 1 tickets free!)</WhiteText>
                )}
              </div>
            ) : (
              <div>
                <ItemAddedText>
                  Add Unlimited Tickets to your cart
                </ItemAddedText>
                <WhiteText>
                  Buy 4 Unlimited tickets to get the lowest one free
                </WhiteText>
              </div>
            )}
          </>
        )}
        <div>
          {isEnabled && hasNoRestriction && totalSum >= 4 && (
            <BlackText>Free Tickets : {totalSum >= 6 ? 2 : 1}</BlackText>
          )}
          <BlackText>Total : {amount} QAR</BlackText>
        </div>
        <div>
          <Button
            width="12rem"
            variant="filled"
            endIcon={<BuyIcon src={BuyCart} />}
            label="Add to Cart"
            onClick={onAddToCart}
          />
        </div>
      </StyledStickyCartInner>
    </StyledStickyCart>
  );
};

const StyledStickyCart = styled.div`
  width: 100vw;
  padding: 1.5rem 0;
  position: sticky;
  bottom: 0;
  background: linear-gradient(180deg, #e956da 0%, #e956da 100%);
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  @media only screen and (max-width: 1240px) {
    padding: 0.5rem 6rem;
  }
`;

const StyledStickyCartInner = styled.div`
  width: 1024px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 876px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    > div {
      text-align: center;
    }
  }
`;

const ItemAddedText = styled.div`
  color: white;
  font-weight: 600;
  font-size: 18px;
  @media only screen and (max-width: 576px) {
    font-size: 14px;
  }
`;

const WhiteText = styled.div`
  color: white;
  font-weight: 500;
  @media only screen and (max-width: 576px) {
    font-size: 12px;
  }
`;

const BlackText = styled.div`
  font-weight: 600;
  @media only screen and (max-width: 576px) {
    font-size: 12px;
  }
`;

const BuyIcon = styled.img`
  width: 2rem;
  height: 2rem;
`;

export default StickyCart;
